import { Instructor, Klass, ProgramOutline } from "types";

const klassSeconds = (klass: Klass) => {
  return klass.view0.lengthSeconds;
};

export const klassesMins = (klasses: Klass[]) => {
  const totalSecs = klasses.map(klassSeconds).reduce((a, b) => a + b, 0);
  return Math.ceil(totalSecs / 60);
};

const programSecs = (program: ProgramOutline) => {
  const secsArr = program.stages.map((s) => s.klasses.map(klassSeconds)).flat();
  const totalSecs = secsArr.reduce((a, b) => a + b, 0);
  return totalSecs;
};

export const programHourMins = (program: ProgramOutline) => {
  const totalSecs = programSecs(program);
  const hours = Math.floor(totalSecs / 3600);
  const mins = Math.ceil((totalSecs - hours * 3600) / 60);
  return `${hours}h ${mins}m`;
};

export const programHours = (program: ProgramOutline) => {
  return Math.ceil(programSecs(program) / 3600);
};

export const programNKlasses = (program: ProgramOutline) => {
  return program.stages.map((s) => s.klasses.length).reduce((a, b) => a + b, 0);
};

export const instructorName = (instructor: Instructor) => {
  return `${instructor.firstName} ${instructor.lastName}`;
};

export const freeKlasses = (program: ProgramOutline): Klass[] => {
  return program.stages.map((s) => s.klasses.filter((k) => !k.premium)).flat();
};

const padTimeDigit = (num: number): string => {
  return `${num}`.padStart(2, "0");
};

export const videoLength = (seconds: number): string => {
  return `${padTimeDigit(Math.floor(seconds / 60))}:${padTimeDigit(
    seconds % 60
  )}`;
};
